import { FormControl, Radio, RadioGroup } from "@material-ui/core";
import { InputRadioFormControl, InputRadioLabel } from "./styles/Inputs";

/**
 *
 * @param {string} label - Título do grupo;
 * @param {array} options - Array de objetos com as opções á serem selecionadas;
 * @param {object} value - Estado com o valor do input;
 * @param {function} setValue - Função que seta o estado do valor do input;
 */
const InputRadio = ({
  label = "",
  options = [],
  value,
  setValue = () => {},
  row = false,
}) => {
  const handleChange = (ev) => {
    setValue(options.find((e) => e.value === ev.target.value));
  };

  return (
    <FormControl component="fieldset">
      {label && <InputRadioLabel component="legend">{label}</InputRadioLabel>}
      <RadioGroup
        aria-label={label.toLowerCase().replaceAll(/[^0-9a-zA-Z]/g, "-")}
        name={label.toLowerCase().replaceAll(/[^0-9a-zA-Z]/g, "-")}
        value={value?.value ?? null}
        onChange={handleChange}
        row={row}
      >
        {options.map((option, i) => (
          <InputRadioFormControl
            key={
              typeof option.value === "string"
                ? option.value.toLowerCase().replaceAll(/[^0-9a-zA-Z]/g, "-")
                : i
            }
            value={option.value}
            control={<Radio />}
            label={option.label}
          />
        ))}
      </RadioGroup>
    </FormControl>
  );
};

export default InputRadio;
